import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/movie", label: "电影" },
  { to: "/tv", label: "电视剧" },
  { to: "/news", label: "资讯" },
  { to: "/special", label: "专题" },
  { to: "/about", label: "关于" },
];

export default function Header() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = !isHome || scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-gradient-to-b from-foreground-950/60 to-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <div className="flex items-center gap-6 lg:gap-10">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer group">
            <span
              className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors ${
                solid
                  ? "bg-primary-500 text-background-50"
                  : "bg-accent-500 text-foreground-950"
              }`}
            >
              <i className="ri-film-line text-lg" />
            </span>
            <span
              className={`font-heading text-xl md:text-2xl tracking-wide ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              影视工厂
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-3 lg:px-4 py-2 text-sm rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "text-accent-500 font-medium"
                      : solid
                        ? "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                        : "text-background-100 hover:text-accent-400"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            aria-label="搜索"
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
              solid
                ? "text-foreground-700 hover:bg-background-100 hover:text-primary-500"
                : "text-background-100 hover:bg-background-50/20"
            }`}
          >
            <i className="ri-search-line text-lg" />
          </Link>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((open) => !open)}
            className={`md:hidden w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
              solid
                ? "text-foreground-950 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/20"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-fade-in">
          <nav className="px-4 py-3 flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-base cursor-pointer transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-700 font-medium"
                      : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/search"
              className="mt-1 px-4 py-3 rounded-md text-base text-foreground-800 hover:bg-background-100 flex items-center gap-2 cursor-pointer"
            >
              <i className="ri-search-line" />
              搜索影视内容
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}